import { render, staticRenderFns } from "./matterTip.vue?vue&type=template&id=b578de72&scoped=true"
import script from "./matterTip.vue?vue&type=script&lang=js"
export * from "./matterTip.vue?vue&type=script&lang=js"
import style0 from "./matterTip.vue?vue&type=style&index=0&id=b578de72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578de72",
  null
  
)

export default component.exports